const collection = {
    slug: "junya-watanabe-man-2027ss-bling-bling-bling-guide",
    metaTitle:
      "JUNYA WATANABE MAN 2027SS Bling Bling Blingとは｜装飾・コラボ ジュンヤワタナベ買取レンタルガイド",
    metaDescription:
      "JUNYA WATANABE MAN 2027SS『Bling Bling Bling』を解説。ヒップホップ由来の装飾的誇示、ストリート、スポーツ、テーラリング、ワークウェア、コラボレーション、キャップ、チェーン、ジュエル、フェイク紙幣、Kappa、Needles、Levi’s、New Balance、Tricker’sなどを通じて、渡辺淳弥がメンズウェアの品性と俗っぽさをどう衝突させたのかをEnclopedia独自の視点で読み解き、JUNYA WATANABE MANレンタル・価買取高致します。",
    metaKeywords:
      "JUNYA WATANABE MAN 2027SS,JUNYA WATANABE MAN 2027春夏,ジュンヤワタナベマン 2027SS,ジュンヤワタナベマン 2027春夏,JUNYA WATANABE MAN Bling Bling Bling,ジュンヤワタナベマン Bling Bling Bling,ジュンヤワタナベマン ブリンブリン,JUNYA WATANABE MAN Kappa,JUNYA WATANABE MAN Needles,JUNYA WATANABE MAN 47,JUNYA WATANABE MAN DHL,JUNYA WATANABE MAN Levi's,JUNYA WATANABE MAN New Balance,JUNYA WATANABE MAN Tricker's,JUNYA WATANABE MAN Carhartt,JUNYA WATANABE MAN Union LA,JUNYA WATANABE MAN 買取,ジュンヤワタナベマン 買取,JUNYA WATANABE MAN レンタル,ジュンヤワタナベマン レンタル,COMME des GARCONS 買取,コムデギャルソン 買取,Enclopedia,アンクロペディア",
    canonicalPath:
      "/archive_collection/junya-watanabe-man-2027ss-bling-bling-bling-guide",
    heroImage:
      "media/archive_fashion/archive32.png",
    heroImageAlt:
      "JUNYA WATANABE MAN 2027SS Bling Bling Blingを解説するEnclopediaアーカイブガイド画像",
    heroNumber: "32 / BLING BLING BLING",
    label: "ARCHIVE COLLECTION STUDY",
    title:
      "JUNYA WATANABE MAN 2027SS『Bling Bling Bling』",
    lead:
      "JUNYA WATANABE MAN 2027SS『Bling Bling Bling』。\n\nこのテーマを、単に“キラキラした装飾”として読むと浅くなります。\n\nBling Bling。\n\nそれは、ヒップホップ文化を通じて広がった、金、ジュエリー、チェーン、宝石、成功、見せつける豊かさ、そして少し過剰な自己演出を含む言葉です。\n\nしかし渡辺淳弥がJUNYA WATANABE MANで扱うとき、そのBlingは単なるラグジュアリーの誇示ではありません。\n\nストリートの派手さ。\nスポーツブランドのロゴ。\n野球帽。\n金色のチェーン。\nコイン。\nジュエル。\nフェイク紙幣。\nテーラリング。\nワークウェア。\nスニーカー。\n革靴。\nトラックジャケット。\n企業ロゴ。\nイタリアンシャツ。\nリーバイス501。\n\nそれらが、一つの身体の上に過剰に集められる。\n\n2027SSで渡辺が作ったのは、“上品なメンズウェア”ではありません。\nそして、単なる“ストリートウェア”でもありません。\n\n上品さと俗っぽさ。\n高級と安っぽさ。\nスポーツとテーラリング。\nワークとジュエリー。\n本物のブランドと偽物のような過剰装飾。\n\nそれらを同じ身体の上で衝突させたコレクションです。\n\nEnclopediaでは、JUNYA WATANABE MAN 2027SSを、販売前の新作情報としてではなく、渡辺淳弥が長年続けてきた“本物の服を借りて、別の価値へ変える”方法論が、装飾と俗っぽさの方向へ振り切られたシーズンとして読み解きます。",
    keywordLine: [
      "junya watanabe man 2027ss",
      "bling bling bling",
      "streetwear tailoring",
      "collaboration archive",
    ],
    thesis:
      "JUNYA WATANABE MAN 2027SS『Bling Bling Bling』の本質は、装飾を足したことではなく、メンズウェアが持つ“上品／下品”“本物／偽物”“ストリート／テーラリング”“スポーツ／ラグジュアリー”という価値判断を、チェーン、キャップ、ジュエル、ロゴ、コラボレーションによって一つの身体上で衝突させた点にあります。",
    whyTitle:
      "なぜJUNYA WATANABE MANは、いま“Bling Bling Bling”を扱ったのか。",
    whyBody:
      "JUNYA WATANABE MANは、長年“本物の服”を扱ってきたラインです。\n\nLevi’sの501。\nCarharttのワークウェア。\nFilsonのアウトドア。\nBrooks Brothersのトラッド。\nAlpha Industriesのミリタリー。\nNew Balanceのスニーカー。\nTricker’sの革靴。\n\n渡辺淳弥にとって、コラボレーションは単なるブランドロゴの足し算ではありません。\n\nそれぞれのブランドが持つ歴史、用途、記号、素材、形を借りて、オーソドックスな服に別の創造性を加える方法です。\n\n2027SSでは、その方法論が“Bling”へ向かいます。\n\nBlingとは、本来きれいな上品さではありません。\nむしろ、少し過剰で、少し俗っぽく、少し見せつけるような輝きです。\n\n高級でありながら、下品にも見える。\n成功の記号でありながら、偽物っぽくも見える。\n装飾でありながら、文化的な自己主張でもある。\n\n渡辺は、この曖昧さを使っています。\n\nキャップにチェーンやジュエルを盛る。\nトラックスーツにブークレを使う。\nイタリアンテーラリングやシャツをスポーツウェアの中に切り貼りする。\nLevi’s 501を前後反転させる。\n靴を肩線のように扱う。\n\nつまり、服のジャンルを分類できない状態へ追い込んでいる。\n\nEnclopediaでは、このシーズンを“派手なコレクション”ではなく、メンズウェアの価値判断そのものを混乱させるコレクションとして見ます。",
    pillars: [
      {
        number: "01",
        title: "BLING AS CULTURAL CONFLICT",
        text:
          "Blingは単なる輝きではありません。成功、過剰、俗っぽさ、ヒップホップ、ストリート、富の誇示、偽物っぽさまで含む文化的記号です。渡辺はそれをメンズウェアの品性と衝突させています。",
      },
      {
        number: "02",
        title: "COLLABORATION AS MATERIAL",
        text:
          "Kappa、Needles、’47、DHL、Levi’s、New Balance、Tricker’sなどのコラボレーションは、話題作りではなく、メンズウェアの異なる価値体系を混ぜる素材として機能しています。",
      },
      {
        number: "03",
        title: "DECODED MENSWEAR",
        text:
          "このコレクションは一目で理解する服ではありません。キャップ、チェーン、ロゴ、フェイク紙幣、靴、テーラリング、スポーツウェアが重なり、着るというより読む必要がある服になっています。",
      },
      {
        number: "04",
        title: "ARCHIVE VALUE BEFORE RELEASE",
        text:
          "2027SSはまだ販売前のシーズンです。だからこそ、過去のJUNYA WATANABE MANにおけるコラボレーション、装飾、パッチワーク、再構築アイテムを再評価する入口になります。",
      },
    ],
    readingTitle:
      "Bling、キャップ、チェーン、Kappa、Needles、Levi’s、New Balance、Tricker’s、テーラリングから読むJUNYA WATANABE MAN 2027SS。",
    readingIntro:
      "2027SS『Bling Bling Bling』は、装飾のコレクションではありません。渡辺淳弥は、ヒップホップ由来のBling、野球帽、チェーン、コイン、ジュエル、フェイク紙幣、スポーツブランド、革靴、イタリアンテーラリング、ワークウェアを同じ身体上に集めることで、メンズウェアの“上品さ”そのものを混乱させました。これは、派手さではなく価値判断のコラージュです。",
    observations: [
      {
        index: "01",
        title:
          "“Bling Bling Bling”は、輝きではなく価値判断の衝突である",
        text:
          "Bling Blingという言葉には、単なるキラキラ以上の意味があります。\n\n金。\nジュエリー。\nチェーン。\n宝石。\n成功。\n見せつける豊かさ。\nヒップホップ。\nストリート。\n少し過剰で、少し俗っぽい装飾。\n\nつまりBlingは、上品なラグジュアリーとは違います。\n\nむしろ、上品さと下品さの境界にある。\n\n渡辺淳弥は、その境界をJUNYA WATANABE MANへ持ち込みました。\n\nただ服を光らせたわけではない。\nメンズウェアにおいて何が上品で、何が下品で、何が本物で、何が偽物っぽいのかという判断そのものを混乱させています。",
      },
      {
        index: "02",
        title:
          "このシーズンは、ストリート対テーラリングという単純な図式を壊している",
        text:
          "メンズウェアではよく、ストリートとテーラリングが対立項として語られます。\n\nスーツか、ストリートか。\n上品か、ラフか。\nクラシックか、若者文化か。\n\nしかし2027SSのJUNYA WATANABE MANでは、その分類が成立しません。\n\nトラックジャケットにテーラリング素材が入る。\nキャップにジュエルやチェーンが積まれる。\nイタリアンシャツがスポーツウェアと切り貼りされる。\n革靴の記号が身体の別の場所へ移される。\n\nこれはストリートとテーラリングの融合ではありません。\n\n融合というより、分類不能化です。\n\nEnclopediaでは、このシーズンを“ストリート×テーラリング”ではなく、メンズウェアのジャンル分けを崩すコレクションとして読みます。",
      },
      {
        index: "03",
        title:
          "キャップは、頭に被るものではなく“装飾の台座”になっている",
        text:
          "2027SSで最も象徴的なのは、キャップです。\n\n’47のMLBキャップ。\nUnion LA。\nDHL。\nそこにチェーン、コイン、ジュエル、JW MANの文字が盛られる。\n\n本来、キャップはカジュアルで実用的なものです。\n日差しを避ける。\nチームを示す。\nストリート感を出す。\n\nしかしこのシーズンでは、キャップは頭に被る道具以上のものになっています。\n\n装飾の台座です。\n\n帽子の上にBlingが積まれることで、頭部はステータスと俗っぽさの展示台になる。\n\nジュエリーは首や指にあるものではなく、キャップにまで侵食する。\n\nこの過剰さが、テーマを最も分かりやすく表しています。",
      },
      {
        index: "04",
        title:
          "KappaのOminiロゴは、男／女、スポーツ／装飾、俗／上品の混合を象徴している",
        text:
          "Vogueは、今季の重要な協業としてKappaを挙げています。\n\nKappaのOminiロゴは、背中合わせに座る男女のシルエットです。\n\nこのロゴは、スポーツウェアの記号であると同時に、身体の二重性を持っています。\n\n男と女。\nスポーツとファッション。\n実用と装飾。\n\n2027SSでは、このKappa的なスポーツの記号が、Blingの過剰装飾やテーラリングと混ざる。\n\nつまり、スポーツウェアが健康的な服ではなくなる。\n\n金属、ジュエル、チェーン、テーラリング、ワークウェアと混ざることで、Kappaは身体を動かす服ではなく、身体に記号を貼り重ねるための素材になります。",
      },
      {
        index: "05",
        title:
          "Needlesとのハイブリッドは、“服のジャンル”を一着の中で混線させている",
        text:
          "Needlesとの協業では、ハリントン、トラックジャケット、ブルゾン、ワークウェア、テーラリング素材が混ざっています。\n\nこれは非常にJUNYA WATANABE MANらしい操作です。\n\nハリントンは英国的で軽いブルゾン。\nトラックジャケットはスポーツウェア。\nワークディテールは労働の服。\nテーラリング素材は上品な服。\n\n本来なら別々の場所に属する服です。\n\nしかし渡辺は、それを一着の中で混線させる。\n\nこの混線によって、服はどのジャンルにも完全には属さなくなる。\n\nBling Bling Blingとは、ジュエリーだけの話ではありません。\n服のジャンルそのものが過剰に装飾され、読みにくくなることなのです。",
      },
      {
        index: "06",
        title:
          "ブークレのトラックスーツは、スポーツウェアを“高そうで変なもの”に変える",
        text:
          "Vogueは、ブークレがトラックスーツに使われていたことにも触れています。\n\nブークレは、凹凸のある高級感の強い素材です。\n\n一方、トラックスーツはスポーツやジャージの文脈を持つ服です。\n\nその二つが合わさると、奇妙なズレが生まれます。\n\nスポーツウェアなのに、素材は上品。\n動くための服なのに、質感はラグジュアリー。\nラフな服なのに、妙に高そうに見える。\n\nここにBlingの本質があります。\n\nただ光っているからBlingなのではありません。\n本来の服の階級がズレること自体がBlingなのです。",
      },
      {
        index: "07",
        title:
          "フェイク紙幣は、富の記号を本物ではなく“プリント”として扱う",
        text:
          "今季の装飾には、フェイク紙幣のようなモチーフも含まれています。\n\n紙幣は、富そのものを表す記号です。\n\nしかし、それがフェイクとして服に付くとき、富は本物ではなく表面になります。\n\nこれは非常に重要です。\n\nBlingは、富を見せる文化です。\nしかしJUNYA WATANABE MANのBlingは、富そのものではなく、富の見え方を服に貼り付けている。\n\nつまり、成功や金銭の記号を少し疑っている。\n\nフェイク紙幣は、成金趣味の肯定ではなく、富のイメージがどれだけ表面化しているかを見せるディテールです。",
      },
      {
        index: "08",
        title:
          "Levi’s 501の前後反転は、“本物”を裏返す行為である",
        text:
          "Levi’s 501は、渡辺淳弥にとって重要な“本物”の一つです。\n\nVogue Businessで渡辺は、Levi’s 501のような本物を取り入れることによって、オーソドックスな服に創造的価値を加えると語っています。\n\n2027SSでは、その501が前後反転されていました。\n\nこれは単なる変形ではありません。\n\n本物を裏返す行為です。\n\n501は、ジーンズの正統性そのものです。\nポケットの位置、フロント、バック、ヒップ、ステッチ。\n\nそれを反転することで、誰もが知っている“本物”が、急に読みにくくなる。\n\nBlingが富の記号をずらすように、501の反転はデニムの正統性をずらしています。",
      },
      {
        index: "09",
        title:
          "New BalanceやTricker’sの靴は、足元ではなく身体の構造線へ移される",
        text:
          "Vogueは、New BalanceやTricker’sの靴が、足元のシルエットではなく肩線を定義するように使われていたと述べています。\n\nこれは非常に渡辺淳弥的な発想です。\n\n靴は本来、足に履くものです。\nしかし渡辺は、それを身体の別の場所へ移す。\n\n靴の形、ソール、革、重さ、記号性が、肩や上半身の構造を作る。\n\nつまり、アイテムの用途がずらされる。\n\nBling Bling Blingの過剰さは、アクセサリーだけではありません。\n\n本来あるべき場所から物を移動させることで、身体全体が装飾化されているのです。",
      },
      {
        index: "10",
        title:
          "DHLキャップは、配送・物流・企業ロゴをファッションのBlingへ変える",
        text:
          "DHLのキャップは、非常に面白い記号です。\n\nDHLは物流のブランドです。\n荷物を運ぶ。\n配送する。\n企業ロゴとして都市に存在する。\n\nそれがキャップになり、さらにBlingで飾られる。\n\nこのとき、企業ロゴはユニフォームや物流の記号ではなく、ファッションの装飾になります。\n\nVogueは、このDHLキャップに初期Vetementsへの参照の可能性も見ています。\n\nつまり、ファッションは企業ロゴを借り、意味を変える。\n\n渡辺淳弥にとって、DHLは単なる面白いロゴではありません。\n“配送する”という企業の意味まで含めて、メッセージを運ぶキャップになっているのです。",
      },
      {
        index: "11",
        title:
          "イタリアンテーラリングは、上品さを保証するためではなく、混乱を深めるために使われている",
        text:
          "Luigi Borrelli、Guy Rover、Maria Santangeloのようなイタリアンシャツやテーラリングの要素も、このシーズンでは重要です。\n\n普通なら、イタリアンテーラリングは上品さ、職人性、クラシック、洗練を保証する記号です。\n\nしかし2027SSでは、それがスポーツウェアやBlingと切り貼りされる。\n\nつまり、上品さがそのまま残らない。\n\nテーラリングはストリートに汚され、スポーツウェアに飲み込まれ、装飾によって俗っぽくなる。\n\nここで起きているのは、テーラリングの格下げではありません。\n\nむしろ、上品さが他の価値とぶつかることで、メンズウェアの階級構造が見えるようになります。",
      },
      {
        index: "12",
        title:
          "“本物”を集めすぎることで、逆に偽物っぽく見せている",
        text:
          "JUNYA WATANABE MANの協業は、“本物”を扱うことに意味があります。\n\nLevi’s。\nKappa。\nNeedles。\nNew Balance。\nTricker’s。\nCarhartt。\nDHL。\nLuigi Borrelli。\n\nどれも、それぞれの領域では本物です。\n\nしかし2027SSでは、その本物が一つの身体に過剰に集められます。\n\n本物が多すぎる。\nロゴが多すぎる。\n記号が多すぎる。\n装飾が多すぎる。\n\nすると、不思議なことに、全体は少し偽物っぽく見えてくる。\n\nここがこのコレクションの面白さです。\n\n本物を積み重ねることで、真正性そのものが揺らぐ。\n\nBling Bling Blingとは、本物と偽物の境界を過剰によって曖昧にするテーマでもあります。",
      },
      {
        index: "13",
        title:
          "これは“着る服”というより“解読する服”である",
        text:
          "Vogueは、このコレクションを一目で読む服ではなく、解読する服として見ています。\n\nこれはEnclopediaの視点とも一致します。\n\nJUNYA WATANABE MAN 2027SSは、シンプルに着てかっこいい服というより、何がどこから来ているのかを読ませる服です。\n\nこのキャップはどこのものか。\nなぜここにチェーンがあるのか。\nなぜ靴が肩線になるのか。\nなぜ501が前後逆なのか。\nなぜトラックスーツにブークレなのか。\n\n服が問いを発生させる。\n\nそして、その問いの多さこそがBlingです。\n\n装飾が多いのではなく、意味が多すぎるのです。",
      },
      {
        index: "14",
        title:
          "販売前シーズンだからこそ、過去のJUNYA WATANABE MANを再評価する入口になる",
        text:
          "2027SSは、まだ販売前のシーズンです。\n\nつまり、今すぐこのシーズンのアイテムを所有することはできません。\n\nしかし、だからこそ過去のJUNYA WATANABE MANを見直す意味があります。\n\nコラボレーションアイテム。\nLevi’s再構築。\nCarharttやFilsonとのワークウェア。\nNew BalanceやTricker’sなどのシューズ文脈。\nキャップやロゴ、スポーツウェア、テーラリングのハイブリッド。\n\n2027SSによって、これらの過去作は新しい文脈を持ちます。\n\n単なるコラボ古着ではなく、渡辺淳弥が“本物の服”をどのように別の価値へ変換してきたかを示すアーカイブになる。\n\nEnclopediaでは、販売前の新作記事を、過去アーカイブの買取・レンタルへ接続する入口として設計します。",
      },
      {
        index: "15",
        title:
          "買取で見るべきなのは、コラボ名だけではなく“過剰さの構造”である",
        text:
          "JUNYA WATANABE MANの買取では、コラボブランド名だけで判断すると見誤ります。\n\nもちろんLevi’s、New Balance、Tricker’s、Carhartt、Filson、Kappa、Needlesなどの協業は重要です。\n\nしかし本当に見るべきなのは、その協業がどのように服の構造へ入り込んでいるかです。\n\nロゴが付いているだけなのか。\n元の服のディテールが解体されているのか。\nスポーツ、ワーク、テーラリング、ストリートが一着の中で衝突しているのか。\n装飾が単なる飾りではなく、服の意味を変えているのか。\n\n2027SSの視点から見ると、JUNYA WATANABE MANの価値は“有名ブランドとのコラボ”ではなく、“どれだけ本物の服を別の価値へ変えているか”にあります。",
      },
      {
        index: "16",
        title:
          "レンタルで分かるのは、派手さではなく“意味の重さ”である",
        text:
          "JUNYA WATANABE MANのような服は、画像だけでは理解しきれません。\n\nキャップの重さ。\nチェーンの揺れ。\nロゴの位置。\n異素材の切り替え。\n靴やデニムの記号性。\nスポーツウェアとテーラリングが同じ身体に乗ったときの違和感。\n\n実際に着ることで、派手な服なのか、読ませる服なのかが分かります。\n\nBling Bling Blingの面白さは、単に目立つことではありません。\n\n目立ちすぎる記号が身体の上に積み重なったとき、自分がどう見えるのか。\n\nEnclopediaのレンタル体験は、その過剰な記号を身体で確認するための方法になります。",
      },
    ],
    quote:
      "JUNYA WATANABE MAN 2027SSのBlingとは、装飾ではない。本物の服、本物のブランド、本物の記号を過剰に積み上げることで、メンズウェアの上品さと俗っぽさを同時に露出させる方法です。",
    perspectiveTitle:
      "Enclopediaは、JUNYA WATANABE MAN 2027SSを“派手なコラボシーズン”ではなく“メンズウェアの価値判断をBlingで混乱させるアーカイブ”として扱う。",
    perspectiveCards: [
      {
        number: "01",
        title: "KNOWLEDGE",
        text:
          "Bling Bling Blingを、単なるキラキラではなく、ヒップホップ、富、俗っぽさ、ストリート、ラグジュアリー、偽物っぽさまで含む文化的記号として整理します。",
      },
      {
        number: "02",
        title: "EXPERIENCE",
        text:
          "JUNYA WATANABE MANのコラボアイテムは、実際に着ることで理解が深まります。ロゴ、チェーン、キャップ、素材切替、構造の過剰さをレンタルで体験できます。",
      },
      {
        number: "03",
        title: "ARCHIVE VALUE",
        text:
          "2027SSは販売前でも、過去のLevi’s、Carhartt、Filson、New Balance、Tricker’sなどのコラボ・再構築アイテムの価値を再文脈化します。",
      },
    ],
    experienceTitle:
      "JUNYA WATANABE MAN 2027SSを読む前に、過去の“コラボレーションと再構築”の価値を確認する。",
    experienceBody:
      "JUNYA WATANABE MAN 2027SS『Bling Bling Bling』は、まだ販売前のシーズンです。\n\nだからこそ、今見るべきなのは過去の関連アーカイブです。\n\nLevi’s 501の再構築。\nCarharttやFilsonのワークウェア。\nNew BalanceやTricker’sとのシューズ文脈。\nKappaやNeedlesのようなスポーツ／ストリート系協業。\nキャップ、ロゴ、パッチワーク、異素材切替、テーラリングとスポーツウェアの混合。\n\n2027SSの“Bling”は、これらを単なるコラボ古着ではなく、メンズウェアの価値判断を揺さぶるアーカイブとして再評価する視点を与えます。\n\nEnclopediaでは、JUNYA WATANABE MANをブランド名やコラボ名だけで査定するのではなく、どのように本物の服が再構築され、どのような過剰さや違和感を生んでいるかまで確認します。",
    experienceItems: [
      "JUNYA WATANABE MANのタグ・AD表記・シーズンを確認する",
      "Levi’s、Carhartt、Filson、New Balance、Tricker’s、Kappa、Needlesなど協業元を確認する",
      "コラボブランド名だけでなく、服の構造にどれだけ組み込まれているか確認する",
      "キャップ、チェーン、ロゴ、パッチ、フェイク紙幣、ジュエル、装飾的ディテールの有無を確認する",
      "スポーツウェア、ワークウェア、テーラリング、ストリート要素が一着の中で混ざっているか確認する",
      "Levi’s 501再構築、前後反転、パッチワーク、ポケット配置、異素材切替を撮影する",
      "New Balance、Tricker’sなどシューズ関連アイテムや付属品がある場合は箱・替紐・タグも撮影する",
      "汚れ、擦れ、破れ、パーツ欠損、ジップ不良、プリント剥がれ、チェーンや装飾の欠損を確認する",
      "シーズン不明の場合もLINEで写真を送る",
    ],
    archiveItemsTitle:
      "2027SS『Bling Bling Bling』を入口に、JUNYA WATANABE MANの買取・レンタルへ。",
    archiveItemsBody:
      "Enclopediaでは、JUNYA WATANABE MANを単なるコラボ古着としてではなく、渡辺淳弥の“本物の服”への敬意、協業ブランドの文脈、装飾、再構築、素材、現在の需要まで含めて見ています。2027SSでこのテーマに触れた方は、過去のJUNYA WATANABE MANアーカイブも、まずはLINEでご相談ください。",
    archiveItems: [
      {
        label: "BUYBACK FOCUS 01",
        title: "JUNYA WATANABE MANの価値を相談する",
        productPath:
          "https://line.me/R/ti/p/@240yzqkh",
        productImage: "",
        text:
          "JUNYA WATANABE MANのコラボアイテム、Levi’s再構築、Carhartt、Filson、New Balance、Tricker’s、Kappa、Needles、装飾的なアイテムまで。シーズン文脈込みで確認します。",
      },
      {
        label: "BUYBACK FOCUS 02",
        title: "COMME des GARCONS買取ページへ",
        productPath:
          "/brand_buyback/comme-des-garcons",
        productImage: "",
        text:
          "COMME des GARCONS、JUNYA WATANABE、JUNYA WATANABE MAN、HOMME PLUSなど、コムデギャルソン関連ブランド全体の買取相談へ進めます。",
      },
      {
        label: "RENTAL FOCUS 03",
        title: "レンタルできるJUNYA WATANABEを見る",
        productPath:
          "JUNYA%20WATANABE（ジュンヤワタナベ）/?number=32",
        productImage: "",
        text:
          "JUNYA WATANABE MANのコラボレーション、再構築、ワークウェア、デニム、装飾性は、実際に着ることで理解が深まります。Enclopediaでジュンヤ ワタナベのアーカイブを体験できます。",
      },
      {
        label: "BUYBACK FOCUS 04",
        title: "JUNYA WATANABE買取ページへ",
        productPath:
          "/brand_buyback/junya-watanabe",
        productImage: "",
        text:
          "JUNYA WATANABE MAN 2023AW Innerraumを含むジャケット、コート、パンツ、バッグ、コラボアイテムまで。ジュンヤワタナベの買取対象と査定視点を確認できます。",
      },
    ],
    finalCta: {
      title:
        "2027SS『Bling Bling Bling』を読んだら、次はJUNYA WATANABE MANの過去作を確認する。",
      body:
        "JUNYA WATANABE MAN 2027SS『Bling Bling Bling』は、まだ販売前のシーズンです。\nしかし、このテーマによって過去のコラボレーション、Levi’s再構築、CarharttやFilsonのワークウェア、New BalanceやTricker’sのシューズ文脈、ロゴや装飾を持つアイテムは、もう一度新しい意味を持ち始めます。\n\nEnclopediaでは、JUNYA WATANABE MANの買取相談を入口に、シーズン背景、協業元、装飾、再構築、レンタル体験までつなげます。\nまずはLINEでタグ・品質表示・全体写真・ディテール写真をお送りください。",
      buttonLabel: "JUNYA WATANABE MANをLINEで事前査定する",
      buttonHref: "https://line.me/R/ti/p/@240yzqkh",
    },
  };
  
  export default collection;